import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import BranchOff from "./BranchOff/BranchOff";
import InnerText from "./InnerText/InnerText";
import { makeSelectPpl } from "slices/efficeCacheSlice";
import { makeSelectNotify } from "slices/sharedSelectors";

//#region OLD SUB EFFICE VIEW CALC
// import { getDateFromTimestamp } from "helpers/efficeHelpers";
// const determineSubEfficeView = (currentEff) => {
//   let effContent = currentEff.content;
//   if (effContent === null) {
//     return "newMember";
//   }
//   return "normalDetailed";

//   // if (nextEff && (nextEff.pinned || nextEff.content === null || ppl > 0)) {
//   //   return "normalDetailed";
//   // }
//   // // Check if the effice was sent on the same Day
//   // if (nextEff && nextEff.creator.id === currentEff.creator.id) {
//   //   let nextEffTime = getDateFromTimestamp(nextEff.created_at);
//   //   let currentEffTime = getDateFromTimestamp(currentEff.created_at);
//   //   if (nextEffTime === currentEffTime) {
//   //     return "normalMinimised";
//   //   }
//   // }
//   // return "normalDetailed";
// };
//#endregion

const TextEfficeItem = ({ id, myId }) => {
  const efficeData = useSelector((state) => state.efficeCache.data[id]);
  const selectPpl = useMemo(makeSelectPpl, []);
  const selectNotify = useMemo(makeSelectNotify, []);
  const notify = useSelector((state) => selectNotify(state, efficeData.id));
  const ppl = useSelector((state) => selectPpl(state, id));

  // window.efs_debug && window.log("TEXT EFFICE ITEM RENDERD");

  return (
    <div className="text-item-wrapper">
      <div
        className={`text-item ${
          efficeData.content === null ? "newMember" : ""
        }`}
      >
        <InnerText
          efficeData={efficeData}
          ppl={ppl}
          subEfficeView={
            efficeData.content === null ? "newMember" : "normalDetailed"
          }
          myId={myId}
        />
        <div className="Txt-effice-right-spacer"></div>
        <BranchOff efficeData={efficeData} notify={notify} />
      </div>
    </div>
  );
};

export default TextEfficeItem;
